import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import VendorCustomerList from "./vendorcustomerdetails";
import Footer from "./Footer";
const CustomerList = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <VendorCustomerList />
      <Footer />
    </>
  );
};

export default CustomerList;
